import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useFormikContext, getIn } from 'formik';

import Field from 'core/components/form/form.v2';
import Divider from 'core/components/divider';
import Label from 'core/components/label/label';

import useStyles from './exclusions.styles';

const ExteriorWallSurfacingExclusionSection = ({ fieldName, disabled }) => {
  const classes = useStyles();
  const { values, setFieldValue } = useFormikContext();

  const exteriorWallSurfacingExclusion = getIn(values, `${fieldName}.exteriorWallSurfacingExclusion`);

  return (
    <Grid item xs={12}>
      <div className={classes.container}>
        <Grid container>
          <Field
            xs={12}
            type="switch"
            id={`${fieldName}.exteriorWallSurfacingExclusion`}
            name={`${fieldName}.exteriorWallSurfacingExclusion`}
            mode="dark"
            label="Exterior wall surfacing exclusion"
            disabled={disabled}
            onChange={(_e, checked) => {
              if (!checked) {
                setFieldValue(`${fieldName}.exteriorWallSurfacingExclusionDetails`, undefined);
              }
            }}
          />
        </Grid>
        {exteriorWallSurfacingExclusion && (
          <>
            <Divider className={classes.divider} />
            <Label className={classes.label}>Exterior wall surfacing exclusion</Label>
            <Grid container spacing={2}>
              <Field
                xs={12}
                type="textarea"
                id={`${fieldName}.exteriorWallSurfacingExclusionDetails`}
                name={`${fieldName}.exteriorWallSurfacingExclusionDetails`}
                mode="dark"
                label="Description of reason for excluding the selected items (required)"
                rows={3}
                disabled={disabled}
              />
            </Grid>
          </>
        )}
      </div>
    </Grid>
  );
};

ExteriorWallSurfacingExclusionSection.propTypes = {
  fieldName: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

ExteriorWallSurfacingExclusionSection.defaultProps = {
  disabled: false
};

export default observer(ExteriorWallSurfacingExclusionSection);
